export const CONTROLS_BUTTON_BASE_CLASSES = [
  'bg-none',
  'border-2',
  'border-solid',
  'border-transparent',
  'cursor-pointer',
  'focus:border-white',
  'outline-none',
  'p-1.5',
  'rounded-full',
  '[&>svg]:w-8',
  '[&>svg]:h-8',
  '[&>svg]:fill-white',
  '[&>svg]:hover:fill-white',
  '[&>svg]:focus:fill-white',
  '[&>svg]:disabled:fill-white-player',
  'disabled:opacity-30',
  'disabled:cursor-auto'
];
